<template>
    <div 
        class="formfield" 
        :class="{'formfield--error': (error)}">
        <label
            v-if="label"
            class="formfield__label">
            {{ label }}
            <span
                class="required"
                v-if="required">*</span>
        </label>

        <div 
            class="formfield__input formfield__password">
            <div class="formfield__password__field">
                <input 
                    :type="inputType" 
                    ref="currentValue" 
                    :value="value" 
                    @input="updateValue()" 
                    @focus="removeError" 
                    :placeholder="placeholder" >

                <a 
                    class="formfield__password__toggle" 
                    @click.prevent="togglePassword">
                    <i 
                        class="icon-view" 
                        v-if="inputType === 'password'"/>
                    <i 
                        class="icon-hide" 
                        v-else-if="inputType === 'text'"/>
                </a>
            </div>

            <div 
                class="formfield__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    $_veeValidate: {
        value () {
            return this.$refs.currentValue.value;
        }
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
        errors: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        error() {
            return this.errors.first(this.name);
        },
        inputType() {
            return this.type || 'text';
        },
    },
    data() {
        return {
            type: 'password',
        };
    },
    methods: {
        removeError() {
            this.errors.remove(this.name);
        },
        updateValue() {
            this.$emit('input', this.$refs.currentValue.value);
        },
        togglePassword() {
            this.type = this.type === 'password' ? 'text' : 'password';
        },
    },
};
</script>
